import React from 'react';
import {
  Box,
  Flex,
  Text,
  Button,
  Spacer
} from '@chakra-ui/react';
import { FiArrowLeft } from 'react-icons/fi';

import SearchAndFilters from './SearchAndFilters';

const Header = ({ users, boardTitle, boardData, searchValue, onSearchChange, onFilterOpen, onReset }) => {

  return (
    <Box bg="white" borderBottom="1px" borderColor="#DFE1E6" px={6} py={4}>
      <Flex align="center">
        {/* Back Button */}
        <Button
          size="sm"
          variant="outline"
          colorScheme="blue"
          leftIcon={<FiArrowLeft />}
          onClick={() => window.history.back()}
          mr={4}
        >
          Back
        </Button>

        {/* Board Title */}
        <Text fontSize="20px" fontWeight="600" color="#172B4D">
          {boardTitle || 'Kanban Board'}
        </Text>

        <Spacer />

        {/* Search and Filters Component */}
        <SearchAndFilters
          users={users}
          searchValue={searchValue}
          onSearchChange={onSearchChange}
          onFilterOpen={onFilterOpen}
          onReset={onReset}
        />
      </Flex>
    </Box>
  );
};

export default Header;